import { render, staticRenderFns } from "./Members2023.vue?vue&type=template&id=16ce1b37&scoped=true"
import script from "./Members2023.vue?vue&type=script&lang=js"
export * from "./Members2023.vue?vue&type=script&lang=js"
import style0 from "./Members2023.vue?vue&type=style&index=0&id=16ce1b37&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ce1b37",
  null
  
)

export default component.exports